import { useState } from 'react'

export const JobState = () => {
    
    const [jobInfo, setJobInfo]= useState ([])
    const [desktopJobInfo, setDesktopJobInfo]= useState ([])
    const [jobList, setJobList]= useState ([])
    const [desktopViewList, setDesktopViewList]= useState ([])
    const [apList, setApList]= useState ([])
    const [totalApplied, setTotalApplied]= useState ([])
    const [dBoardLoader, setDBoardLoader] = useState(false)
    const [dBoardPslLoader, setDBoardPslLoader] = useState(false)
    const [info, setInfo]= useState ([])
    const [loader, setLoader] =useState(false)
    const [apLoader, setApLoader] =useState(true)
    const [whatNextModal, setWhatNextModal] =useState(false)
    const [resumeLoader, setResumeLoader] =useState(true)
    const [isLoader, setIsLoader] =useState(true)
    const [id, setId] = useState()
    const [cId, setCId] = useState()
    const [cafguModal, setCafguModal] =useState(false)
    const [existUsrModal, setExistUsrModal] =useState(false)
    const [welcomeModal, setWelcomeModal] = useState(false)
    const [resumeModal, setResumeModal]= useState(false)
    const [pslTour, setPslTour] = useState(false)
    const [pslTourData, setPslTourData]= useState([])
    const [desktopTour, setDesktopTour] = useState(false)
    const [desktopTourData, setDesktopTourData]= useState([])
    const [resumeData, setResumeData]= useState([])
    const [resumeReadData, setResumeReadData]= useState([])
    const [viewResume, setViewResume]= useState(false)
    const [applicanStatus, setApplicantStatus] = useState([])
    const [jobStatusPrsonalization, setJobStatusPrsonalization] = useState([])
    const [jobListPrsonalization, setJobListPrsonalization] = useState([])
    const [psnalizationReadData, setPsnalizationReadData]= useState([])
    const [jobStatusLoader, setJobStatusLoader] = useState(false)
    const [desktopViewLoader, setDesktopViewLoader] = useState(false)
    const [whatNextApplied, setWhatNextApplied] = useState([])
    const [whatNextLoader, setWhatNextLoader] = useState(false)
    const [psnalizationStatusRead, setPsnalizationStatusRead] = useState([])
    const [psnalizationListRead, setPsnalizationListRead] = useState([])
    const [careerRead, setCareerRead] = useState([])
    const [mobilevldt, setMobilevldt] = useState([])
    const [mobilevldtLoader, setMobilevldtLoader] = useState(false)
    const [jobRedirectPrsonalization, setJobRedirectPrsonalization] = useState(false)
    const [whatsNextStat, setWhatsNextStat] = useState(false)
    const [desktopPreview, setDesktopPreview] = useState(false)
    const [desktopInfo, setDesktopInfo] = useState(false)
    const [previewInfo, setPreviewInfo] = useState(false)
    const [listForm, setListForm] = useState ({
        type: "create",
        submit: {modal: false, type: '', confirmed: false},
        inputs:{
            name: {value: '', stat: false, msg: '', toggled: false},
            position: {value: '', stat: false, msg: '', toggled: false},
            qualification: [{value: '', stat: false, msg: '', toggled: false}],
            description: [{value: '', stat: false, msg: '', toggled: false}],
            benefits: [{value: '', stat: false, msg: '', toggled: false}],
            banner: {value: null, object: '', name: '', type: 'default', size: 0, updated: false, stat: false, msg: {value: '', stat: false, msg: ''}},
            logo: {value: '', object: '', name: '', type: 'default', size: 0, updated: false, stat: false, msg: {value: '', stat: false, msg: ''}},
            location: {value: '', stat: false, msg: '', toggled: false},
            overview: {value: '', stat: false, msg: '', toggled: false},
            start_date: {value: 1, stat: false, msg: '', toggled: false},
            end_date: {value: 1, stat: false, msg: '', toggled: false},
            status: {value: 1, stat: false, msg: '', toggled: false},
            user_id: {value: 1, stat: false, msg: '', toggled: false},
            company_id: {value: 1, stat: false, msg: '', toggled: false},
        }
    })
    const [jobForm, setJobForm] = useState ({
        type: "create",
        submit: {modal: false, type: '', confirmed: false},
        inputs:{
            first_name: {value: '', stat: false, msg: '', toggled: false},
            last_name: {value: '', stat: false, msg: '', toggled: false},
            suffix: {value: '', stat: false, msg: '', toggled: false},
            contact_info: {value: '', stat: false, msg: '', toggled: false},
            job_id: {value: '', stat: false, msg: '', toggled: false},
            email_account: {value: '', stat: false, msg: '', toggled: false},
        }
    })
    const [career, setCareer] = useState ({
        type: "create",
        submit: {modal: false, type: '', confirmed: false},
        inputs:{
            status: {value: 2, stat: false, msg: '', toggled: false},
            active: {value: 1, stat: false, msg: '', toggled: false},
            data_status: {value: '', stat: false, msg: '', toggled: false},
            created_by: {value: '', stat: false, msg: '', toggled: false},
            user_id: {value: '', stat: false, msg: '', toggled: false},
            start_date: {value: '', stat: false, msg: '', toggled: false},
            end_date: {value: '', stat: false, msg: '', toggled: false},
            job_id: {value: '', stat: false, msg: '', toggled: false},
           
        }
    })

    const [whatNextValidation, setWhatNextValidation] = useState(true)

  return {
      jobForm: {data: jobForm, set: setJobForm},
      jobInfo: {data: jobInfo, set: setJobInfo},
      desktopJobInfo: {data: desktopJobInfo, set: setDesktopJobInfo},
      listForm: {data: listForm, set: setListForm},
      jobList: {data: jobList, set: setJobList},
      totalApplied: {data: totalApplied, set: setTotalApplied},
      career: {data: career, set: setCareer},
      loader: {data: loader, set: setLoader},
      apLoader: {data: apLoader, set: setApLoader},
      isLoader: {data: isLoader, set: setIsLoader},
      id:{data: id, set: setId},
      cId:{data: cId, set: setCId},
      info: {data: info, set: setInfo},
      dBoardLoader: {data: dBoardLoader, set: setDBoardLoader},
      cafguModal:{data: cafguModal, set: setCafguModal},
      welcomeModal: {data: welcomeModal, set: setWelcomeModal},
      pslTour:{data: pslTour, set: setPslTour},
      pslTourData: {data: pslTourData, set: setPslTourData},
      desktopTour:{data: desktopTour, set: setDesktopTour},
      desktopTourData: {data: desktopTourData, set: setDesktopTourData},
      resumeModal: {data:resumeModal, set:setResumeModal},
      resumeData: {data:resumeData, set:setResumeData},
      resumeReadData: {data: resumeReadData, set:setResumeReadData},
      viewResume: {data:viewResume, set:setViewResume},
      resumeLoader: {data:resumeLoader, set:setResumeLoader},
      apList:{data:apList, set:setApList},
      whatNextModal: {data:whatNextModal, set:setWhatNextModal},
      applicanStatus: {data:applicanStatus, set:setApplicantStatus},
      jobStatusLoader: {data:jobStatusLoader, set:setJobStatusLoader},
      psnalizationReadData: {data:psnalizationReadData, set:setPsnalizationReadData},
      whatNextApplied:{data:whatNextApplied, set:setWhatNextApplied},
      whatNextLoader:{data:whatNextLoader, set:setWhatNextLoader},
      jobStatusPrsonalization: {data:jobStatusPrsonalization, set:setJobStatusPrsonalization},
      jobListPrsonalization: {data:jobListPrsonalization, set:setJobListPrsonalization},
      psnalizationStatusRead: {data:psnalizationStatusRead, set:setPsnalizationStatusRead},
      psnalizationListRead: {data:psnalizationListRead, set:setPsnalizationListRead},
      jobRedirectPrsonalization:{data:jobRedirectPrsonalization, set:setJobRedirectPrsonalization},
      whatNextValidation:{data:whatNextValidation, set:setWhatNextValidation},
      whatsNextStat:{data:whatsNextStat, set:setWhatsNextStat},
      dBoardPslLoader:{data: dBoardPslLoader, set:setDBoardPslLoader},
      careerRead:{data: careerRead, set:setCareerRead},
      existUsrModal:{data: existUsrModal, set: setExistUsrModal },
      mobilevldt:{data: mobilevldt, set: setMobilevldt},
      mobilevldtLoader:{data: mobilevldtLoader, set:setMobilevldtLoader},
      desktopViewList:{data: desktopViewList, set:setDesktopViewList},
      desktopPreview:{data: desktopPreview, set:setDesktopPreview},
      desktopViewLoader:{data: desktopViewLoader, set:setDesktopViewLoader},
      desktopInfo:{data: desktopInfo, set:setDesktopInfo},
      previewInfo:{data: previewInfo, set:setPreviewInfo}
      
  }
  
}
